import { getContainerSize } from "./config";

class Resizer {
  constructor(container, camera, renderer) {
    const setSize = () => {
      const { width, height, aspect } = getContainerSize(container);
      camera.aspect = aspect;
      camera.updateProjectionMatrix();
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      renderer.setSize(width, height);
      this.onResize();
    };

    setSize();

    this._onWinResize = () => setSize();
    window.addEventListener("resize", this._onWinResize);

    if (typeof ResizeObserver !== "undefined" && container) {
      this._ro = new ResizeObserver(() => setSize());
      this._ro.observe(container);
    }
  }

  destroy() {
    window.removeEventListener("resize", this._onWinResize);
    if (this._ro) this._ro.disconnect();
  }

  onResize() {}
}

export { Resizer };
